<template>
  <span class="wrapper">
    <!-- <span
      class="web__msg--audio"
      @mouseup="handleMouseUp"
      v-if="getTag === 'span'"
      v-html="parseText()"
    /> -->
    <span
      class="web__msg--audio showSpace"
      @mouseup="handleMouseUp"
      v-if="getTag === 'span'"
      v-html="parseText()"
    >
    </span>
    <img
      class="web__msg--img"
      v-if="getTag === 'img'"
      :src="getData.src"
      alt
      @click="showDialog({ tag: 'img' })"
    />
    <video
      class="web__msg--video"
      v-if="getTag === 'video'"
      :src="getData.src"
      controls="controls"
      @click="showDialog({ tag: 'video' })"
    />
    <audio
      class="web__msg--audio"
      v-if="getTag === 'audio'"
      style="width: 20rem; height: 20px"
      :src="getData.src"
      controls="controls"
    />

    <el-dialog
      :visible.sync="show"
      width="40%"
      append-to-body
      :before-close="handleClose"
      class="web__dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <img :src="imgSrc" v-if="imgSrc" style="width: 100%; object-fit: cover" />
      <video
        :src="videoSrc"
        v-if="videoSrc"
        style="width: 100%; object-fit: cover"
        controls="controls"
      ></video>
      <audio
        :src="audioSrc"
        v-if="audioSrc"
        style="width: 100%; object-fit: cover"
        controls="controls"
      ></audio>
    </el-dialog>
  </span>
</template>

<script>
import emojiParser from "wechat-emoji-parser";
export default {
  props: {
    text: String,
  },
  data() {
    return {
      tags: ["img", "video", "audio"],
      /* 查看文件详情 */
      show: false,
      imgSrc: "",
      videoSrc: "",
      audioSrc: "",
      //   选中复制的文字
      copyText: "",
      expressionList: {
        "[微笑]": "/::)",
        "[调皮]": "/::P",
        "[色]": "/::B",
        "[睡]": "/::Z",
        "[疑问]": "/:?",
        "[流泪]": "/::<",
        "[汗]": "/::L",
        "[晕]": "/:,@@",
        "[撇嘴]": "/::~",
        "[惊恐]": "/::!",
        "[尴尬]": "/::-|",
        "[害羞]": "/::$",
        "[委屈]": "/:P-('; //'/::'|",
        "[大笑]": "/::D",
        "[大哭]": "/::'(",
        "[可爱]": "/:,@-D",
        "[再见]": "/:bye",
        "[偷笑]": "/:,@P",
        "[乖]": ":flushed:", //无资源
        "[难过]": "/::('; //'/:X-)",
      },
    };
  },
  computed: {
    getTag() {
      const str = this.text || "";
      let tag = "span";
      let type = "";

      const isTag = str.match(/(?!^<)[A-Z|a-z]+/);
      isTag && (type = isTag[0]);
      if (this.tags.includes(type)) {
        tag = type;
      }
      return tag;
    },
    getData() {
      const str = this.text || "";
      const dom = document.createElement("div");
      dom.innerHTML = str;
      const target = dom.firstChild;

      const src = target.getAttribute("data-src");
      const controls = target.getAttribute("controls") || false;
      console.log("itemTalk src = ", src);
      console.log("itemTalk controls = ", controls);
      return {
        src,
        controls,
      };
    },
    // 获取关键字列表
    specialKeywords() {
      return this.$store.state.specialDisplayKeywords || [];
    },
  },
  methods: {
    // 鼠标按下复制选中的文字
    handleMouseUp() {
      console.log(this.copyText);
      var selection = window.getSelection();
      this.copyText = selection.toString();
      console.log(this.copyText);
      this.$emit("getChildText", this.copyText);
    },
    handleClose(done) {
      this.imgSrc = undefined;
      this.videoSrc = undefined;
      this.audioSrc = undefined;
      done();
    },
    showDialog({ tag }) {
      const { src } = this.getData;
      const callback = () => {
        if (tag === "img") {
          this.imgSrc = src;
          this.show = true;
        } else if (tag === "video") {
          this.videoSrc = src;
          this.show = true;
        } else if (tag === "audio") {
          this.audioSrc = src;
          this.show = true;
        } else if (tag === "FILE") {
          window.open(src);
        }
      };
      if (typeof this.beforeOpen === "function") {
        this.beforeOpen(
          {
            tag,
            src,
          },
          callback
        );
      } else {
        callback();
      }
    },
    parseText() {
      let { text } = this;
      // // 文字长度超过250，截取处理
      // if (text.length > 250) {
      //   text= text.slice(0,249)
      // }
      if (!text) return;
      text = text.replace(/\n/g, "<br/>");
      for (const key in this.expressionList) {
        text = text.replaceAll(key, this.expressionList[key]);
      }

      // 处理表情解析
      let html = emojiParser(text).replace(
        /<img src/g,
        '<img data-class="iconBox" src'
      );

      // 高亮关键字（在HTML标签外进行替换）
      html = this.highlightKeywords(html);
      
      return html;
    },
    // 高亮关键字方法
    highlightKeywords(html) {
      if (!html || !this.specialKeywords || this.specialKeywords.length === 0) {
        return html;
      }

      // 按长度降序排序，优先匹配长关键字
      const sortedKeywords = [...this.specialKeywords]
        .filter(keyword => keyword && keyword.trim() !== '')
        .sort((a, b) => b.length - a.length);

      if (sortedKeywords.length === 0) {
        return html;
      }

      // 使用正则表达式匹配HTML标签外的文本内容
      // 这个正则会匹配不在HTML标签内的文本
      return html.replace(/(<[^>]*>)|([^<]+)/g, (match, tag, text) => {
        // 如果是HTML标签，直接返回
        if (tag) {
          return tag;
        }
        
        // 如果是文本内容，进行关键字匹配
        if (text) {
          let result = text;
          
          // 遍历所有关键字进行匹配
          for (const keyword of sortedKeywords) {
            // 转义关键字中的特殊字符
            const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            // 使用正则匹配，不区分大小写
            const regex = new RegExp(escapedKeyword, 'gi');
            
            // 使用全局匹配，逐个处理每个匹配项
            let match;
            const matches = [];
            while ((match = regex.exec(result)) !== null) {
              matches.push({
                index: match.index,
                length: match[0].length,
                text: match[0]
              });
            }
            
            // 从后往前处理，避免索引变化问题
            for (let i = matches.length - 1; i >= 0; i--) {
              const matchItem = matches[i];
              const start = matchItem.index;
              const end = start + matchItem.length;
              
              // 检查这个位置是否已经在高亮标签内
              const beforeText = result.substring(0, start);
              const openTags = (beforeText.match(/<span class="keyword-highlight">/g) || []).length;
              const closeTags = (beforeText.match(/<\/span>/g) || []).length;
              
              // 如果开标签数大于闭标签数，说明当前位置已经在标签内，跳过
              if (openTags <= closeTags) {
                const matchedText = matchItem.text;
                const replacement = `<span class="keyword-highlight">${matchedText}</span>`;
                result = result.substring(0, start) + replacement + result.substring(end);
              }
            }
          }
          
          return result;
        }
        
        return match;
      });
    },
    //处理排版
    /*  handleDetail (html = '') {
       let tag = 'span'
       let options = {}
       if (this.isObject(html)) {
         const { type, content } = html
         tag = type
         options = content
       } else {
         tag = this.getTag(html)
       }
 
       this.createdElement(tag, content)
 
       let result = html;
       result = emojiParser(result).replace(/(<img src)/g, '<img data-class="iconBox" data-src')
       setTimeout(() => {
         const list = this.$refs.content;
         list.forEach(ele => {
           for (let i = 0; i < ele.children.length; i++) {
             const child = ele.children[i];
             child.onload = this.childnodeLoad
             // console.log(child.parentNode)
             if (child.getAttribute('data-flag') != 0) {
               child.setAttribute('data-flag', 0)
               child.onclick = () => {
                 this.handleEvent(child)
               };
               if (child.tagName === 'IMG') {
                 child.className = 'web__msg--img'
                 const icon = child.getAttribute('data-class')
                 if (icon !== 'iconBox') child.type = "IMG"
                 child.src = child.getAttribute('data-src')
               } else if (child.tagName === 'VIDEO') {
                 child.type = "VIDEO"
                 child.className = 'web__msg--video'
                 child.src = child.getAttribute('data-src')
               } else if (child.tagName === 'AUDIO') {
                 child.type = "AUDIO"
                 child.className = 'web__msg--audio'
                 child.controls = 'controls';
                 child.src = child.getAttribute('data-src')
               } else if (child.tagName === 'FILE') {
                 child.type = "FILE"
                 child.className = 'web__msg--file'
                 child.innerHTML = `<h2>File</h2><span>${child.getAttribute('data-name')}</span>`
               } else if (child.tagName === 'MAP') {
                 child.type = "MAP"
                 child.className = 'web__msg--file web__msg--map'
                 child.innerHTML = `<h2>Map</h2><span>${child.getAttribute('data-longitude')} , ${child.getAttribute('data-latitude')}<br />${child.getAttribute('data-address')}</span>`
               }
             }
           }
         });
         console.log('n')
       }, 200)
       return result;
     }, */
  },
};
</script>
<style lange="scss" scoped>
.wrapper {
  padding: 0px;
  margin: 0px;
}
span {
  -webkit-user-select: text;
  user-select: text;
}
.showSpace {
  white-space: pre-wrap;
}
</style>
<style lang="scss">
/* 关键字高亮样式 - 全局样式，因为是通过v-html插入的 */
.keyword-highlight {
  color: #FF0000 !important;
  font-weight: 800 !important;
  font-size: 1.05em !important;
  text-shadow: 0 0 1px rgba(255, 0, 0, 0.3) !important;
}
</style>
